<template>
  <a-card>
    <div class="ant-descriptions-title">
      Logo
    </div>
    <a-upload-dragger
      name="file"
      @change="handleChange"
      :showUploadList="false"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        Click or drag file to this area to upload
      </p>
    </a-upload-dragger>
    <div v-if="previewImage" style="text-align: right; max-width: 400px;">
      <br />
      <a-tooltip title="Xóa">
        <a-button type="link" @click="removeImage">
          <a-icon type="close" style="color: #dc3545;" />
        </a-button>
      </a-tooltip>
      <img alt="previewImage" style="width: 100%;" :src="previewImage" />
    </div>
  </a-card>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  props: {},
  data() {
    return {
      previewImage: "",
    };
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
    },
    handleChange({ fileList }) {
      if (fileList && fileList.length > 0) {
        this.handlePreview(fileList[fileList.length - 1]);
      }
    },
    removeImage() {
      this.previewImage = "";
    },
  },
};
</script>
<style lang="css" scoped></style>
